import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'

export default {
  namespaced: true,
  state: {
    isLoading: false,
    tonsIa: [],
    listDataInitialByJob: [],
    librariePrompt: {
      count: 0,
      prompts: []
    },
    prompt: {
      annonceurId: 0,
      defaut: false,
      diffuseurId: -1,
      donnees: [],
      id: null,
      prompt: '',
      reseau: null,
      temperature: 0.1,
      titre: '',
      ton: ''
    },
    infos: {
      annonceurId: null,
      diffuseurId: null
    },
    mode: null,
    loadingPromptSimulate: false,
    promptSimulate: null
  },
  getters: {
    getTonsIa: (state) => state.tonsIa,
    getListDataInitialByJob: (state) => state.listDataInitialByJob,
    getLibrariePrompt: (state) => state.librariePrompt.prompts,
    getPrompt: (state) => state.prompt,
    getCountAllPrompts: (state) => state.librariePrompt.count,
    getIsLoading: (state) => state.isLoading,
    getLoadingPromptSimulate: (state) => state.loadingPromptSimulate,
    getPromptSimulate: (state) => state.promptSimulate
  },
  mutations: {
    setTonsIa (state, data) {
      state.tonsIa = data
    },
    setLoadingPrompt (state, bool) {
      state.isLoading = bool
    },
    setListDataInitialByJob (state, data) {
      state.listDataInitialByJob = data
    },
    updateLibrariePrompt (state, updatedPrompt) {
      const librariePrompt = state.librariePrompt.prompts
      const index = librariePrompt.findIndex(prompt => prompt.id === updatedPrompt.id)
      if (index !== -1) {
        librariePrompt[index] = updatedPrompt
        state.librariePrompt.prompts = librariePrompt
      }
    },
    addPromptInLibrary (state, prompt) {
      state.librariePrompt.prompts.unshift(prompt)
    },
    resetLibrariePrompts (state, data) {
      state.librariePrompt.prompts = data.prompts
      state.librariePrompt.count = data.count
    },
    deletedPrompt (state, prompt) {
      const librariePrompt = state.librariePrompt.prompts
      const index = librariePrompt.indexOf(prompt)
      if (index > -1) {
        state.librariePrompt.prompts.splice(index, 1)
      }
    },
    setPrompt (state, prompt) {
      state.prompt = prompt
    },
    setDonnees (state, checkedData) {
      const donnees = state.listDataInitialByJob.filter((donnee) => checkedData.includes(donnee.libelle))
      state.prompt.donnees = donnees
    },
    setAnnonceurId (state, annonceurId) {
      state.prompt.annonceurId = annonceurId
    },
    setMode (state, mode) {
      state.mode = mode
    },
    resetPrompt (state) {
      state.prompt = {
        annonceurId: 0,
        defaut: 0,
        diffuseurId: -1,
        donnees: [],
        id: null,
        prompt: '',
        reseau: null,
        temperature: 0.1,
        titre: '',
        ton: ''
      }
      state.promptSimulate = ''
    },
    setInfos (state, { annonceurId, diffuseurId }) {
      state.infos.annonceurId = annonceurId
      state.infos.diffuseurId = diffuseurId
    },
    setLoadingPromptSimulate (state, bool) {
      state.loadingPromptSimulate = bool
    },
    setPromptSimulate (state, promptSimulate) {
      state.promptSimulate = promptSimulate
    }
  },
  actions: {
    loadTonsIa (context) {
      context.commit('setLoadingPrompt', true)
      HTTP_HYPER_ESPACE_BACKEND.get('/tons-ia')
        .then((response) => {
          context.commit('setTonsIa', response.data)
        }).catch((error) => {
          console.log(error)
        }).finally(() => {
          context.commit('setLoadingPrompt', false)
        })
    },
    loadListDataInitialByJob (context) {
      context.commit('setLoadingPrompt', true)
      HTTP_HYPER_ESPACE_BACKEND.get('/donnees-annonceurs')
        .then((response) => {
          context.commit('setListDataInitialByJob', response.data)
        }).catch((error) => {
          console.log(error)
        }).finally(() => {
          context.commit('setLoadingPrompt', false)
        })
    },
    loadPrompts ({ commit, rootState }) {
      const sitimmoUser = rootState.app.sitimmoUser
      commit('setLoadingPrompt', true)
      HTTP_HYPER_ESPACE_BACKEND.get(`/get-prompts?annonceurId=${sitimmoUser.id}&tri[direction]=asc&tri[sort]=id`)
        .then((response) => {
          const data = response.data
          if (data.count > 0) {
            // En attendant pour les datums
            const prompts = data.prompts.map(prompt => {
              return Object.assign({}, prompt, {
                donnees: (prompt.datum && prompt.datum.champs) ? prompt.datum.champs : null
              })
            })
            const result = { count: data.count, prompts: prompts }
            commit('resetLibrariePrompts', result)
          }
        }).catch((error) => {
          console.log(error)
        }).finally(() => {
          commit('setLoadingPrompt', false)
        })
    },
    callSimulate (context) {
      context.state.promptSimulate = null
      context.commit('setLoadingPromptSimulate', true)
      const currentPrompt = context.state.prompt
      const newSimulatePrompt = {
        annonceurId: currentPrompt.annonceurId,
        defaut: currentPrompt.defaut,
        diffuseurId: -1,
        mode: context.state.mode,
        prompt: {
          version: 'v3',
          id: currentPrompt.id,
          donnees: currentPrompt.donnees,
          contrainte: currentPrompt.miseEnForme,
          miseEnForme: currentPrompt.miseEnForme
        },
        reseau: null,
        temperature: 0.1,
        titre: currentPrompt.titre,
        ton: currentPrompt.ton
      }
      HTTP_HYPER_ESPACE_BACKEND.post('/simulate', newSimulatePrompt)
        .then((response) => {
          context.commit('setPromptSimulate', response.data.text)
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          context.commit('setLoadingPromptSimulate', false)
        })
    },
    addPrompt (context, prompt) {
      context.commit('setLoadingPrompt', true)
      HTTP_HYPER_ESPACE_BACKEND.post('/add-prompt', prompt)
        .then((response) => {
          context.commit('addPromptInLibrary', prompt)
        }).catch((error) => {
          console.log(error)
        }).finally(() => {
          context.commit('setLoadingPrompt', false)
          if (!context.state.infos.diffuseurId) {
            context.dispatch('loadPrompts')
          } else {
            context.dispatch('loadLibraryPromptByDiffuseur', { annonceurId: context.state.infos.annonceurId, diffuseurId: context.state.infos.diffuseurId })
          }
        })
    },
    editPrompt (context, prompt) {
      context.commit('setLoadingPrompt', true)
      const uri = `/update-prompt/${prompt.id}`
      HTTP_HYPER_ESPACE_BACKEND.put(uri, prompt)
        .then((response) => {
          context.commit('updateLibrariePrompt', prompt)
        }).catch((error) => {
          console.log(error)
        }).finally(() => {
          context.commit('setLoadingPrompt', false)
          context.dispatch('loadPrompts')
        })
    },
    deletePrompt (context, prompt) {
      const deletedPrompt = prompt
      const uri = `/delete-prompt/${deletedPrompt.id}`
      context.commit('setLoadingPrompt', true)
      HTTP_HYPER_ESPACE_BACKEND.delete(uri)
        .then((response) => {
          context.commit('deletedPrompt', deletedPrompt)
          context.commit('deleteCurrentPromptSimulate', deletedPrompt.id)
        }).catch((error) => {
          console.log(error)
        }).finally(() => {
          context.commit('setLoadingPrompt', false)
          context.dispatch('loadPrompts')
        })
    },
    updatePromptDefault (context, prompt) {
      // const librariePrompt = context.state.librariePrompt
      // const indexPromptSelected = librariePrompt.prompts.findIndex((item) => item.id === prompt.id)
      // const promptFound = librariePrompt.prompts[indexPromptSelected]
      // promptFound.defaut = !promptFound.defaut
      prompt.defaut = true
      context.dispatch('editPrompt', prompt)
    },
    loadLibraryPromptByDiffuseur ({ state, commit, rootState }) {
      const sitimmoUser = rootState.app.sitimmoUser
      const diffuseurId = state.infos.diffuseurId
      const annonceurId = state.infos.annonceurId
      if (diffuseurId && (sitimmoUser.optionIa && sitimmoUser.personnalisationPrompts)) {
        commit('setLoadingPrompt', true)
        HTTP_HYPER_ESPACE_BACKEND
          .get(`/get-prompts?annonceurId=${annonceurId}&diffuseurId=${diffuseurId}`)
          .then((response) => {
            commit('resetLibrariePrompts', response.data)
          })
          .catch((error) => console.log(error))
          .finally(() => {
            commit('setLoadingPrompt', false)
          })
      }
    },
    findPromptAndSend ({ state, commit, dispatch }, { promptId, diffuseurName, post, isNeedSocialNetwork, isBienVendu }) {
      const prompts = state.librariePrompt.prompts
      const indexPromptInStore = prompts.findIndex((prompt) => prompt.id === promptId)

      if (indexPromptInStore > -1 && prompts[indexPromptInStore] !== undefined && prompts[indexPromptInStore].diffuseurId === -1) {
        commit('setLoadingPrompt', true)
        HTTP_HYPER_ESPACE_BACKEND.get(`/diffuseurs?diffuseur=${diffuseurName}`)
          .then((response) => {
            prompts[indexPromptInStore].diffuseurId = response.data
          }).catch((error) => {
            console.log(error)
          }).finally(() => {
            commit('setLoadingPrompt', false)
          })
      }

      if (diffuseurName && promptId) {
        let diffuseur = diffuseurName.split('_')[0]
        if (diffuseur === 'GOOGLE') {
          diffuseur = 'GMB'
        }
        if (!post.post_ia_prompt_custom) {
          post.post_ia_prompt_custom = {}
        }

        if (post.post_ia_prompt_custom[`${diffuseur}`]) {
          // Mise à jour du diffuseur existant
          post.post_ia_prompt_custom[`${diffuseur}`] = { ...post.post_ia_prompt_custom[`${diffuseur}`], ...{ prompt_id: promptId } }
        } else {
          // Ajout d'un nouveau diffuseur
          post.post_ia_prompt_custom[`${diffuseur}`] = { prompt_id: promptId }
        }
        const data = {
          annonceur: {
            login: post.advertiser.login
          },
          flux: {
            code: post.emission.codeName,
            emissionId: post.emission.id
          },
          annonce: {
            post_ia_prompt_custom: post.post_ia_prompt_custom
          }
        }

        if (isNeedSocialNetwork) {
          data.source = { code: 'SOCIAL_NETWORK' }
        }

        HTTP_HYPER_ESPACE_BACKEND.patch(`/annonce/${post.id}`, data)
          .then(response => {
            if (response.status === 200) {
              dispatch('caption/loadCaptionsWithPromptLibrairies', { data: response.data.ad, diffuseurName: diffuseurName }, { root: true })
            }
          }).catch(error => {
            return { type: 'error', message: error }
          })
      }
    }
  }
}
